/* global ViewController, WebView, moment */
var activatePortalController = new ViewController({
    directory : "views/portal",
    name: "activatePortal",
    container: "main",
    route: "activate-portal"
}) ;

activatePortalController.prepareDataOnEnter = function(token, callback){
    this.api.public.getPortalPartnerByActivationCode(token, function(err, partner){
        if(err){ return callback(err) ;}
        this.api.public.getLastTerms(function(err, terms){
            if(err){ return callback(err) ;}
            var data = {
                token: token,
                partner: partner,
                terms: terms
            } ;
            callback(null, data) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

activatePortalController.onOpenTerms = function(){
    var view = new WebView(null, null, {
        html: '<div style="overflow: auto; max-height: calc(100% - 180px);">'+
            (this.data.terms?this.data.terms.terms:"missing terms")+"</div>"

    }) ;
    view.openInPopup({
        size: "wide"
    }) ;
} ;

activatePortalController.onValidate = function(){
    
    let now = new Date();
    if (this.data.partner && this.data.partner.date_activation_expire && 
        new Date(this.data.partner.date_activation_expire) < now) {
        return WebView.error(WebView.tr("activatePortal.dateActivationExpired")) ;
    }

    this.view.longTask(function(done){
        this.view.updateData() ;
        var termsId = null;
        if(this.data.terms){
            termsId = this.data.terms.id ;
        }
        this.api.public.activatePortalPartner(this.data.token, this.data.passwordNew, termsId, function(err){
            if(err){ return done(err) ;}
            done() ;
            WebView.info(WebView.tr("activatePortal.activatedSuccess"), function(){
                this.navigate("/portal") ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

activatePortalController.onForgotPass = function(){
    this.appController.context.controllers.forgotPasswordPortalController.enter() ;
} ;


module.exports = activatePortalController ;